import createIconSet from "./createIconSet";
export default function (config, expoFontName, expoAssetId) {
  var glyphMap = {};
  config.icons.forEach(function (icon) {
    icon.properties.name.split(/\s*,\s*/g).forEach(function (name) {
      glyphMap[name] = icon.properties.code;
    });
  });
  var fontFamily = expoFontName || config.preferences.fontPref.metadata.fontFamily;
  return createIconSet(glyphMap, fontFamily, expoAssetId || fontFamily + ".ttf");
}